import { isTouchDevice } from "../lib/utilities";

if (isTouchDevice) {
   window.addEventListener("DOMContentLoaded", () => {
      document.querySelectorAll(".image-teaser").forEach(element => {
         element.addEventListener("click", (event) => event.currentTarget.classList.toggle("hover"));
      });
   });
}
